import React from 'react';
import PropTypes from 'prop-types';
import { AvailableIcon, CrossIcon } from '@sainsburys-tech/bolt-icons';
import * as Styled from './AvailabilityItem.styles';

var AvailabilityItem = function AvailabilityItem(_ref) {
  var available = _ref.available,
      fulfillmentLabel = _ref.fulfillmentLabel;
  return /*#__PURE__*/React.createElement(Styled.AvailabilityItem, {
    "aria-label": "".concat(fulfillmentLabel, " ").concat(available ? 'available' : 'unavailable')
  }, available && /*#__PURE__*/React.createElement(AvailableIcon, {
    icon: "tick",
    mobile: false,
    size: 14,
    fill: "#008844",
    filled: true
  }), !available && /*#__PURE__*/React.createElement(CrossIcon, {
    icon: "cross",
    mobile: false,
    size: 14,
    fill: "#D42114",
    filled: true
  }), fulfillmentLabel);
};

AvailabilityItem.propTypes = {
  available: PropTypes.bool,
  fulfillmentLabel: PropTypes.string
};
export default AvailabilityItem;